export default class BaseService {}
